import { render } from "./index.vue?vue&type=template&id=462a1704&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=462a1704&scoped=true&lang=css"

import exportComponent from "D:\\Leo\\Frontend\\surveys\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462a1704"]])

export default __exports__